module.exports = __webpack_public_path__ + "assets/img/warrior-name-4e6bfdfb.png";